import { FC, useMemo } from 'react'
import { MapContainerProps } from 'react-leaflet'
import { BaseCadastralPlotFragment } from '@foros-fe/graphql'
import Map from '.'
import { LayerGeoJSON } from './Layers/LayerGeoJSON'
import { cadastralPlotsToGeoJSONData } from '../../utils/cartography'
import { DeflateLayer } from './Layers/DeflateLayer'

type Props = {
  cadastralPlots: BaseCadastralPlotFragment[]
}

const boundsOptions: MapContainerProps['boundsOptions'] = { padding: [20, 20] }

const AuctionCardMap: FC<Props> = ({ cadastralPlots }) => {
  const [bounds, geoJSONData] = useMemo(
    () => cadastralPlotsToGeoJSONData(cadastralPlots),
    [cadastralPlots]
  )

  return (
    <Map staticMap bounds={bounds} fallback={!bounds} boundsOptions={boundsOptions}>
      <DeflateLayer>
        {geoJSONData.map((data, key) => (
          <LayerGeoJSON key={key} color='secondary' data={data} interactive={false} fill={false} />
        ))}
      </DeflateLayer>
    </Map>
  )
}

export default AuctionCardMap
